// @flow
/* eslint-disable no-shadow */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import { Menu, MenuItem } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import Language from '@material-ui/icons/Language';

import * as i18nUtils from '../../utils/i18n';
import { toggleAudioMode, toggleDevMode } from '../../actions';

function LanguageSwitcher({
  displayable,
  i18n,
  toggleDevMode,
  toggleAudioMode,
  t,
}: {
  displayable: Object,
  i18n: Function,
  toggleAudioMode: Function,
  toggleDevMode: Function,
  t: Object,
}) {
  const [devModeComptor, setDevModeComptor] = useState(0);
  const [langAnchorEl, setLangAnchorEl] = useState(null);

  const incrementDevModeComptor = () => {
    if (devModeComptor === 5) {
      toggleDevMode();
    } else if (devModeComptor === 10) {
      setDevModeComptor(0);
      toggleAudioMode();
    }
    setDevModeComptor(devModeComptor + 1);
  };

  const updateLanguage = lang => {
    i18n.changeLanguage(lang, () => {
      window.document.title = t('title');
    });
    setLangAnchorEl(null);
  };

  const handleLangClick = event => {
    setLangAnchorEl(event.currentTarget);
  };

  return (
    <ListItem>
      {displayable.dev && (
        <ListItemText>
          <Typography variant="subtitle1" color="primary" onClick={() => incrementDevModeComptor()}>
            <small>{String(process.env.TAG_COMMIT)}</small>
          </Typography>
        </ListItemText>
      )}
      <button
        style={{
          display: 'flex',
          flexDirection: 'row',
          position: 'absolute',
          right: 10,
        }}
        onClick={handleLangClick}
        className="a-button"
        type="submit"
      >
        <Language
          style={{
            width: 16,
            height: 16,
            marginTop: 8,
            marginRight: 5,
            color: '#777',
          }}
        />
        <Typography
          aria-owns={langAnchorEl ? 'simple-menu' : undefined}
          color="primary"
          aria-haspopup="true"
          variant="subtitle1"
        >
          <small>{t('sidebar.language')}</small>
        </Typography>
      </button>
      <Menu id="simple-menu" anchorEl={langAnchorEl} open={Boolean(langAnchorEl)}>
        {i18nUtils.langs.map(lg => (
          <MenuItem key={lg} onClick={() => updateLanguage(lg)} selected={lg === i18n.language}>
            {i18nUtils.langsDisplay[lg]}
          </MenuItem>
        ))}
      </Menu>
    </ListItem>
  );
}

const mapStateToProps = ({ scribeSession: { displayable } }) => ({
  displayable,
});

export default connect(mapStateToProps, {
  toggleAudioMode,
  toggleDevMode,
})(withTranslation()(LanguageSwitcher));
